import React from "react";
import { Card } from "@sscs/ui";
import { getClassName } from "@sscs/utils";
import styles from "./formPanel.module.scss";

type FormPanelProps = {
  title?: string;
  byline?: string;
  children: React.ReactElement | React.ReactElement[];
  className?: string;
};

const FormPanel = ({
  title,
  byline,
  children,
  className,
}: FormPanelProps): React.JSX.Element => {
  return (
    <Card.Card>
      {title && <Card.Title>{title}</Card.Title>}
      <Card.Content>
        {byline && <span className={styles.byline}>{byline}</span>}
        <div className={getClassName(styles["form-panel-inner"], className)}>
          {children}
        </div>
      </Card.Content>
    </Card.Card>
  );
};

export default FormPanel;
